import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen justify-between" }
const _hoisted_2 = { class: "py-8 border-t bg-gray-200 font-medium" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Wave me 👋")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Lucky number 🎲")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("About")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createVNode(_component_router_view, { class: "container max-w-8xl mx-auto mb-auto px-4" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(_component_router_link, { to: { name: 'WaveMe' } }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6,
      _createVNode(_component_router_link, { to: { name: 'WaveMe' } }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _hoisted_8,
      _createVNode(_component_router_link, { to: { name: 'About' } }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ])
  ]))
}